const BILLING_URL = import.meta.env.VITE_BILLING_WORKER_URL || '';

// Normalises a user-entered VAT string (e.g. "BE 0123.456.789" → { country, number })
export function parseVat(input) {
  const cleaned = (input || '').replace(/\s+/g, '').toUpperCase();
  const m = cleaned.match(/^([A-Z]{2})([0-9]+)$/);
  if (m) return { country: m[1], number: m[2] };
  // Default to BE for numeric-only input
  if (/^[0-9]+$/.test(cleaned)) return { country: 'BE', number: cleaned };
  return null;
}

// Returns { valid: true|false|null, name?, address? }
// valid = null means VIES was unreachable — don't block.
export async function checkVat(rawVat) {
  if (!BILLING_URL) return null; // worker not deployed yet — degrade silently
  const parsed = parseVat(rawVat);
  if (!parsed) return { valid: false, error: 'Invalid format' };
  try {
    const res = await fetch(`${BILLING_URL}/vat-check?country=${parsed.country}&number=${parsed.number}`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
